import React from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import clsx from 'clsx';

function CheckBoxComponent(props) {
  const { labelName, defaultValue, filterAction, disabled, className } = props;

  // const onCheckboxChange = () => {}
  return (
    <div data-testid="check-box-component" className="frr-check-box-component">
      <fieldset
        className={clsx(
          'manufacturer-checkbox custom-fieldset',
          className || 'unique-field-noborder'
        )}
      >
        <legend aria-hidden="true"></legend>
        <FormControlLabel
          control={<Checkbox color="primary" />}
          label={labelName}
          value={defaultValue}
          disabled={disabled || false}
          onChange={(e) => filterAction(!defaultValue)}
          checked={defaultValue}
          data-testid="check-box-change"
        />
      </fieldset>
    </div>
  );
}

export default CheckBoxComponent;
